import React from 'react';

const BusinessProductivityServices = () => {
    return (
        <div>
            <h1>BusinessProductivityServices page</h1>
        </div>
    );
}

export default BusinessProductivityServices;
